<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="80%" persistent>
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("goods.remains") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-row class="mx-0 w-100 mb-5" v-if="!selectedNomenclature">
            <v-col xs="6" md="6" class="pa-0 mx-0">
              <v-card class="pa-3 ma-0" elevation="0">
                <v-text-field
                  outlined
                  :placeholder="$t('goods.start_typing_brand_or_part_code')"
                  append-outer-icon="fa-times"
                  hide-details
                  @click:append-outer="search = ''"
                  v-model="search"
                  class="mb-2"
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
          <v-card v-if="selectedNomenclature" elevation="0">
            <v-card-text>
              <v-card-actions>
                <div>
                  <span class="text-caption d-block"
                    >{{ selectedNomenclature.storage_name }}
                    {{ selectedNomenclature.storage_rack_name }}
                    {{ selectedNomenclature.storage_shelf_name }}</span
                  ><strong
                    >{{ selectedNomenclature.part_code }}
                    {{ selectedNomenclature.brand }}
                    {{ selectedNomenclature.name }}</strong
                  >
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!nomenclature"
                  icon
                  color="yellow"
                  @click="
                    selectedNomenclature = null;
                    nomenclature_remains = null;
                  "
                >
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
          <!--Выбор номенклатуры-->          
          <v-data-table
            v-if="selectedNomenclature === null"
            ref="goodsIncomingTable"
            :headers="goodsRemainsTableHeader"
            :items="goods_remains"
            class="elevation-0 mb-3 w-100"
            :loading="!fetched"
            :disabled="!fetched"
            @update:options="
              (options) => {
                setTableOptions(options);
                getGoodsRemains();
              }
            "
            :server-items-length="itemsTotalCount"
            :options="tableOptions"
            :height="tableHeight"
            :footer-props="{
              'items-per-page-text': $t('tables.items_per_page'),
              'items-per-page-options': [
                10, 50, 100,
                //-1
              ],
            }"
          >
            <template v-slot:footer.page-text="props">
              {{
                $t("tables.x_of_y", [
                  `${props.pageStart}-${props.pageStop}`,
                  props.itemsLength,
                ])
              }}
            </template>
            <template v-slot:item.brand="props">
              <span class="text-no-wrap">
                  {{props.item.brand}}
                </span>
            </template>
            <template v-slot:item.select="props">
              <v-btn
                elevation="0"
                color="primary"
                @click="selectNomenlacture(props.item)"
              >
                <span>{{ $t("common.select") }}</span>
              </v-btn>
            </template>
            <template v-slot:item.price="props">
              <span class="text-no-wrap">
                {{ formatCurrency(props.item.price) }}
              </span>
            </template>
            <template v-slot:item.amount_calculated="props">
              <amount-of-nomenclature
                  :amount="props.item.amount_calculated"
                  :nomenclature="props.item"
              />
              <nomenclature-measurement-short-name :nomenclature="props.item"/>
            </template>
            <template v-slot:item.price_with_margin="props">
              <span class="text-no-wrap">
                {{ formatCurrency(props.item.price_with_margin) }}
              </span>
            </template>
            <template v-slot:item.goods_movement_document_type.name="props">
              <span v-if="props.item.goods_movement_document_type">
                {{
                  $t(
                    "movementDocumentTypes.full." +
                      props.item.goods_movement_document_type.name
                  )
                }}
              </span>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
          <!--Выбор прихода--->
          <v-data-table
            v-if="selectedNomenclature"
            ref="goodsIncomingTable"
            :headers="nomenclatureGoodsMovementsTableHeader"
            :items="
              selectedNomenclatureItems
            "
            :footer-props="{
              'items-per-page-text': $t('tables.items_per_page'),
              'items-per-page-options': [
                10, 50, 100,
                //-1
              ],
            }"
            class="elevation-0 w-100"
            :loading="!is_fetched_nomenclature_remains"
            :disabled="!is_fetched_nomenclature_remains"
          >
            <template v-slot:footer.page-text="props">
              {{
                $t("tables.x_of_y", [
                  `${props.pageStart}-${props.pageStop}`,
                  props.itemsLength,
                ])
              }}
            </template>
            <template v-slot:item.price="props">
              <span class="text-no-wrap">
                {{ formatCurrency(props.item.price) }}
              </span>
            </template>
            <template v-slot:item.price_with_margin="props">
              <span class="text-no-wrap">
                {{ formatCurrency(props.item.price_with_margin) }}
              </span>
            </template>
            <template v-slot:item.select="props">
              <v-btn
                elevation="0"
                color="primary"
                @click="selectIncoming(props.item)"
              >
                <span>{{ $t("common.select") }}</span>
              </v-btn>
            </template>
            <template v-slot:item.chosen_amount="props">
              <v-form :ref="'form_field_' + props.item.id" class="text-no-wrap">

                <v-text-field
                  v-if="isNomenclatureDivisible"
                  :rules="[
                    (v) => !!v || $t('form.validationErrors.field_is_required'),
                    (v) =>
                      (!!v && v.replace(/,/g, '.') > 0) ||
                      $t('form.validationErrors.must_be_greater', [0]),
                    (v) =>
                      (!!v &&
                        v &&
                        v.replace(/,/g, '.') ==
                          parseFloat(v.replace(/,/g, '.'))) ||
                      $t('form.validationErrors.must_be_float'),
                    (v) =>
                      (!!v &&
                        parseFloat(v.replace(/,/g, '.')) <=
                          parseFloat(props.item.available_amount)) ||
                      $t(
                        'form.validationErrors.must_be_less_than_or_equal_to',
                        [props.item.available_amount]
                      ),
                  ]"
                  v-model="props.item.chosen_amount"
                  class="d-inline-flex"
                ></v-text-field>
                <span v-if="!isNomenclatureDivisible">{{props.item.chosen_amount}}</span>
                <nomenclature-measurement-short-name :nomenclature="selectedNomenclature.nomenclature"/>
              </v-form>
            </template>
            <template v-slot:item.available_amount="props">
              <amount-of-nomenclature
                  :amount="props.item.available_amount"
                  :nomenclature="selectedNomenclature.nomenclature"
              />
              <nomenclature-measurement-short-name :nomenclature="selectedNomenclature.nomenclature"/>
            </template>
            <template v-slot:item.basis="props">
              <span class="text-no-wrap">
                <span v-if="parseInt(props.item.operation) === 1">
                  {{ $t("goods.type_incoming") }}
                </span>
                <span v-if="parseInt(props.item.operation) === -1">
                  {{ $t("goods.type_writeoff") }}
                </span>
                <span
                  v-if="
                    props.item.goods_movement_basis &&
                    props.item.goods_movement_basis.goods_movement_document_type
                  "
                >
                  № {{ props.item.goods_movement_basis.human_number }}
                  {{ props.item.goods_movement_basis.date | moment("DD.MM.YYYY") }} [{{
                    $t(
                      "movementDocumentTypes.full." +
                        props.item.goods_movement_basis
                          .goods_movement_document_type.name
                    )
                  }}]
                </span>
              </span>
            </template>
            <template v-slot:no-data>
              {{ $t("common.no_data_available") }}
            </template>
            <template v-slot:no-results>
              {{ $t("common.no_data_available") }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider class=""></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="red" class="white--text" @click="close">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import AmountOfNomenclature from "@/components/storage/AmountOfNomenclature.vue";
import NomenclatureMeasurementShortName from "@/components/storage/NomenclatureMeasurementShortName.vue";

export default {
  name: "ChooseRemainsForm",
  components: {NomenclatureMeasurementShortName, AmountOfNomenclature},
  mixins: [CommonMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    nomenclature: null,
  },
  data: () => ({
    tableHeight: "300",
    findTimeoutId: null,
    selectedNomenclature: null,
  }),
  methods: {
    selectNomenlacture(item) {
      this.selectedNomenclature = item;
    },
    selectIncoming(item) {
      if (!this.$refs["form_field_" + item.id].validate()) return;
      let write_off_item = {
        nomenclature_id: this.selectedNomenclature.id,
        brand: this.selectedNomenclature.brand,
        part_code: this.selectedNomenclature.part_code,
        part_name: this.selectedNomenclature.name,
        amount: parseFloat(item.chosen_amount.toString().replace(/,/g, '.')),
        price: item.price ? item.price : 0,
        storage: item.storage,
        storage_id: item.storage_id,
        rack: item.rack,
        storage_rack_id: item.storage_rack_id,
        shelf: item.shelf,
        storage_rack_shelve_id: item.storage_rack_shelve_id,
        related_item_incoming_id: item.id,
        nomenclature: this.selectedNomenclature,
        platform_supplier: item.platform_supplier,
        platform_supplier_id: item.platform_supplier_id,
      };
      let items = [];
      items.push(write_off_item);
      this.$emit("choose", items);
      this.close();
    },
    close() {
      this.showWindow = false;
    },
    onResize() {
      this.setTableHeight();
    },
    setTableHeight() {
      let rect = this.$refs["goodsIncomingTable"].$el.getBoundingClientRect();
      if (rect) {
        this.tableHeight = window.innerHeight - rect.top - 90;
      }
    },
    setTableOptions(options) {
      this.tableOptions = options;
    },
    getGoodsRemains() {
      this.$store.dispatch("goods_remains/get");
    },
  },
  computed: {
    isNomenclatureDivisible(){ //является ли номенклатура делимой(измеряется в килограммах или литрах)
      return (this.selectedNomenclature.unit_of_measurement && parseInt(this.selectedNomenclature.unit_of_measurement.is_divisible) === 1)
    },
    selectedNomenclatureItems(){
      let data =  (this.nomenclature_remains &&
              this.nomenclature_remains.goods_movements.filter(
                  (item) => item.available_amount > 0
              )) ||
          [];

      if( ! this.isNomenclatureDivisible) {
        if (data.length > 0) {
          for (let i in data) {
            data[i].chosen_amount = 1; //если номенклатура не делимая - сделаем выбранное количество = 1
          }
        }
      }
      return data;
    },
    ...mapFields("goods_remains", [
      "is_fetched_nomenclature_remains",
      "goods_remains",
      "nomenclature_remains",
      "tableOptions",
      "itemsTotalCount",
      "search",
      "fetched",
    ]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
    goodsRemainsTableHeader() {
      return [
        {
          text: this.$t("common.select"),
          value: "select",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.brand"),
          value: "brand",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.part_code"),
          value: "part_code",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.amount"),
          value: "amount_calculated",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price_with_margin"),
          value: "price_with_margin",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage"),
          value: "storage_name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack"),
          value: "storage_rack_name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack_shelve"),
          value: "storage_shelf_name",
          sortable: false,
          class: "text-no-wrap",
        },
      ];
    },
    nomenclatureGoodsMovementsTableHeader() {
      return [
        {
          text: this.$t("common.select"),
          value: "select",
          class: "text-no-wrap",
        },
        {
          text: this.$t("goods.chosen_amount"),
          value: "chosen_amount",
          class: "text-no-wrap",
        },
        {
          text: this.$t("goods.available_amount"),
          value: "available_amount",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price_with_margin"),
          value: "price_with_margin",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.supplier"),
          value: "goods_movement_basis.supplier.name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("goods.basis"),
          value: "basis",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage"),
          value: "storage.name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack"),
          value: "rack.name",
          sortable: false,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewGoods.storage_rack_shelve"),
          value: "shelf.name",
          sortable: false,
          class: "text-no-wrap",
        },
      ];
    },
  },
  watch: {
    selectedNomenclature() {
      if (!this.selectedNomenclature) return;
      this.$store.dispatch("goods_remains/getNomenclatureRemains", {
        id: this.selectedNomenclature.nomenclature_id,
        storage_id: this.selectedNomenclature.storage_id,
        operation: 1,
      });
    },
    search(to) {
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.getGoodsRemains();
      }, 1000);
    },
    show(to) {
      if (to) {
        if (this.nomenclature) {
          this.selectedNomenclature = this.nomenclature;
        }
        this.getGoodsRemains();
      } else {
        this.selectedNomenclature = null;
        this.nomenclature_remains = null;
        this.goods_remains = [];
        this.search = null;
      }
    },
  },
};
</script>

<style scoped></style>
